/**
 * Based on three.js CopyShader.js
 * @author alteredq / http://alteredqualia.com/
 *
 * Full-screen textured quad shader
 *
 * Modifications copyright Higharc Inc. 2019.
 */
import type * as THREE from "three";
import { UVVertexShader } from "./UVVertexShader";

interface SSAAOutputShaderType {
  readonly uniforms: {
    [key: string]: THREE.IUniform;
    tDiffuse: THREE.IUniform;
  };
  readonly vertexShader: string;
  readonly fragmentShader: string;
}

export const SSAAOutputShader: SSAAOutputShaderType = {
  uniforms: {
    tDiffuse: { value: null },
  },

  vertexShader: UVVertexShader,

  fragmentShader: `
		uniform sampler2D tDiffuse;

		varying vec2 vUv;

		// The placeholder lines below are here so that custom postprocessing can be conveniently added to this
		// shader pass. TODO: Maybe add a more robust mechanism for customizing shaders to three.js core?
		// <adjust color params>

		void main() {

			gl_FragColor = texture2D( tDiffuse, vUv );

			// <adjust color>

			#include <colorspace_fragment>

		}`,
} as const;
